import React, { useState, useEffect, useCallback, useRef } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { showSuccessSnackbar } from 'modules/snackbar';
import {
  normalList,
  copyList,
  normalImages,
  statusList,
  changeState,
} from 'lib/api/material';
import { addAllList } from 'modules/common';
import { adGrpStateCodeList, adGrpRsnCode } from 'lib/api/code';
import { makeHeadData } from 'lib/commonLib';

import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import SpanningTableContents from 'components/molecules/MbTable/SpanningTableContents';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

import ImagesModal from './ImagesModal';
import ChangeState from './ChangeState';

const Creative = (props) => {
  const { t } = useTranslation();
  const { type } = props;
  const dispatch = useDispatch();

  const isNormalPage = type === 'normal';
  let initParams = {
    sort: 'desc',
    order: 'LAST_DATE',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    adGrpStateCode: 'all',
  };
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const initImageModal = {
    open: false,
    data: [],
  };
  const initModal = {
    open: false,
    data: null,
    params: {},
  };
  const [ImageModal, setImageModal] = useState(initImageModal);
  const [modal, setModal] = useState(initModal);
  const [approveList, setApproveList] = useState([]);
  const [adGrpRsnCodeList, setAdGrpRsnCodeList] = useState([]);
  const [tableHeadList, setTableHeadList] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [statusLoading, setStatusLoading] = useState(true);
  const [reFetch, setReFetch] = useState(false);
  const [error, setError] = useState({
    adGrpStateCode: false,
    comment: false,
  });
  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  };
  const prevParams = usePrevious(params);

  useEffect(() => {
    adGrpStateCodeList()
      .then((response) => {
        const { data } = response.data;
        const keys = ['mobon', 'kakao'];
        const availableList = ['01','02','99']; // 대기, 승인, 반려만 리스트에 노출
        let newList = [];
        let newHeadList = [
          {
            id: 'all',
            label: t('전체'),
            orderFlag: false,
            type: 'number',
            format: '#,##0',
            displayFlag: true,
          },
        ];
        for (let key of keys) {
          const name = key === 'mobon' ? t('모비온') : t('카카오');
          // eslint-disable-next-line array-callback-return
          data.map((item) => {
            if(availableList.indexOf(item['CODE_ID']) !== -1) {
              if (key === 'mobon') {
                newList.push({
                  label: item['CODE_DESC'],
                  value: item['CODE_ID'],
                });
              }
              if (item['CODE_ID'] === '01') {
                newHeadList.push({
                  id: key + '_all',
                  label: name + ' 전체',
                  orderFlag: false,
                  type: 'number',
                  format: '#,##0',
                  displayFlag: true,
                });
              }
              newHeadList.push({
                id: key + '_' + item['CODE_ID'],
                label: name + ' ' + item['CODE_DESC'],
                orderFlag: false,
                type: 'number',
                format: '#,##0',
                displayFlag: true,
              });
            }
          });
        }
        setApproveList(addAllList(newList, 'label', 'value', 'all'));
        setTableHeadList(newHeadList);
      })
      .catch((error) =>
        handleClickSnackbar({
          message: error,
          option: { type: 'error' },
        })
      );
    adGrpRsnCode()
      .then((response) => {
        const { data } = response.data;
        let newList = [];
        if (isNormalPage) {
          // eslint-disable-next-line array-callback-return
          data.map((item) => {
            newList.push({ label: item['CODE_DESC'], value: item['CODE_ID'] });
          });
        } else {
          // eslint-disable-next-line array-callback-return
          data.map((item) => {
            if (item['CODE_ID'] !== '02') {
              newList.push({
                label: item['CODE_DESC'],
                value: item['CODE_ID'],
              });
            }
          });
        }
        setAdGrpRsnCodeList(newList);
      })
      .catch((error) =>
        handleClickSnackbar({
          message: error,
          option: { type: 'error' },
        })
      );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
    if (reFetch === true) {
      setReFetch(false);
    }
  }, [initialization, reFetch]);

  useEffect(() => {
    if (!!prevParams) {
      if (
        prevParams.keyword === params.keyword &&
        prevParams.sort === params.sort &&
        prevParams.order === params.order
      ) {
        handleGetDashboard();
      }
    } else {
      handleGetDashboard();
    }
    // eslint-disable-next-line
  }, [params, reFetch]);

  const customized = {
    AD_GRP_STATE_STR: {
      makeHead: () => {
        return (
          <SpanningTableContents topTitle={t('승인구분')} type="head">
            <div style={{ width: 60 }}>{t('모비온')}</div>
            <div style={{ width: 60 }}>{t('카카오')}</div>
          </SpanningTableContents>
        );
      },
      makeBody: (rowObj) => {
        return (
          <SpanningTableContents>
            <div style={{ width: 60, padding: '0 10px' }}>
              {stateConver(rowObj, 'AD_GRP_STATE_STR')}
            </div>
            <div style={{ width: 60, padding: '0 10px' }}>
              {stateConver(rowObj, 'BIZ_STATE_STR')}
            </div>
          </SpanningTableContents>
        );
      },
      headStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
      bodyStyle: {
        borderLeft: '1px solid #e5e8eb',
        borderRight: '1px solid #e5e8eb',
      },
    },
    BIZ_STATE_STR: { merged: true },
    INSEP_USER_NM: {
      makeBody: (rowObj) => {
        return rowObj['INSEP_USER_NM'] + '(' + rowObj['INSEP_USER_ID'] + ')';
      },
    },
    MOBON_AD_GRP_ID: { merged: true },
    INSEP_USER_ID: { merged: true },
    STATE_COMMENT: {
      headStyle: { minWidth: 200 },
    },
    MAT_IMG_PATH: { merged: true },
    BK_COLOR: {
      makeHead: () => {
        return t('배경색');
      },
      makeBody: (rowObj) => {
        return (
          <div
            style={{
              display: 'flex',
              width: 140,
              margin: '0 auto',
              justifyContent: 'space-around',
            }}
          >
            {rowObj['BK_COLOR']}
            <div
              style={{
                width: 70,
                height: 20,
                background: rowObj['BK_COLOR'],
                border: '1px solid rgb(0 0 0 / 50%)',
                borderRadius: 4,
              }}
            />
          </div>
        );
      },
      bodyStyle: { justifyContent: 'space-between', alignItems: 'center' },
    },
    AD_GRP_RSN_CODE: { merged: true },
    AD_GRP_RSN_CODE_STR: {
      makeHead: () => {
        return t('사유');
      },
    },
    COPY_STR: {
      makeBody: (rowObj) => {
        let newCopyStr;
        const result = [];
        if (!!rowObj['COPY_STR']) {
          newCopyStr = rowObj['COPY_STR'].split('::');
          for (let i = 0; i < newCopyStr.length; i++) {
            result.push(
              <p key={i}>
                {t('카피문구')}({i + 1 + '): ' + newCopyStr[i]}
                {!!newCopyStr[i] && '/ ' + newCopyStr[i].length + t('자')}
              </p>
            );
          }
        } else {
          result.push(rowObj['COPY_STR']);
        }
        return result;
      },
      bodyStyle: { textAlign: 'left' },
    },
  };

  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      makeRowFunc: (data) => {
        return (
          <TableBtnWrap>
            <NewButton
              title={t('수정')}
              icon="faEdit"
              iconBtn
              onClick={() => handleEdit(data)}
              disableRipple
            />
            {isNormalPage && (
              <NewButton
                title={t('전체이미지')}
                icon="faImages"
                iconBtn
                onClick={() => handleModalOpen(data['MOBON_AD_GRP_ID'])}
                disableRipple
              />
            )}
          </TableBtnWrap>
        );
      },
    });
    return result;
  })();

  const handleGetDashboard = () => {
    setStatusLoading(true);
    statusList({
      params: {
        sDate: params['sDate'],
        eDate: params['eDate'],
        adGrpTpCode: isNormalPage ? '01' : '02',
      },
    })
      .then((response) => {
        const { data } = response.data;
        setStatusData([data]);
      })
      .catch((error) =>
        handleClickSnackbar({
          message: error,
          option: { type: 'error' },
        })
      )
      .finally(() => {
        setStatusLoading(false);
      });
  };

  const stateConver = (rowObj, key) => {
    let result;

    const data = rowObj[key];

    if (!!data) {
      result = (
        <p
          style={{
            padding: !!data && 3,
            backgroundColor:
              data === '승인'
                ? '#ddf7ed'
                : data === '반려'
                ? '#fee4e4'
                : data === '대기'
                ? '#fef3d3'
                : null,
            border: !!data && '1px solid #000',
            borderColor:
              data === '승인'
                ? '#91e5c6'
                : data === '반려'
                ? '#fa6a6a'
                : data === '대기'
                ? '#fac327'
                : null,
            borderRadius: 4,
            color:
              data === '승인'
                ? '#8ce3c3'
                : data === '반려'
                ? '#fa6a6a'
                : data === '대기'
                ? '#fac327'
                : null,
          }}
        >
          {data}
        </p>
      );
    } else {
      result = '-';
    }
    return result;
  };

  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setParams(initParams);
      setInitialization(true);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const getModalParam = (newParams) => {
    if (JSON.stringify(modal.params) !== JSON.stringify(newParams)) {
      setModal({ ...modal, params: newParams });
      let newError = { ...error };
      if (newParams.adGrpRsnCode === '04') {
        newError = { ...newError, adGrpStateCode: false };
        if (!!newParams.comment) {
          newError = { ...newError, comment: false };
        }
      }
      setError(newError);
    }
  };

  const handleCheckBtnController = (type, data) => {
    let newModal = { ...initModal };
    let tmpExlNo = [];
    data.forEach(function (rowData) {
      tmpExlNo.push(rowData['MOBON_AD_GRP_ID']);
    });
    newModal = {
      ...newModal,
      open: true,
      params: { mobonAdGrpId: String(tmpExlNo) },
    };
    setModal(newModal);
  };

  const handleModalOpen = (data) => {
    let newModal = { ...initModal };
    normalImages({ mobonAdGrpId: data })
      .then((response) => {
        const { data } = response.data;
        newModal = { ...newModal, open: true, data: data };
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: { type: 'error' },
        });
      })
      .finally(() => {
        setImageModal({ ...newModal });
      });
  };

  const handleImageModalClose = () => {
    setImageModal({ ...ImageModal, open: false });
  };

  const handleModalClose = () => {
    setModal({ ...modal, open: false, params: {} });
  };

  const handleStatus = (status) => {
    let tempParams = { ...modal.params };
    if (!!status) {
      if (status === '99') {
        if (!tempParams.adGrpRsnCode) {
          handleClickSnackbar({
            message: t('사유를 선택해주세요.'),
            option: { type: 'error' },
          });
          setError({ ...error, adGrpStateCode: true, comment: false });
        } else if (tempParams.adGrpRsnCode === '04') {
          if (!!tempParams.comment) {
            handleReqStatus({ ...tempParams, adGrpStateCode: status });
            setError({ ...error, adGrpStateCode: false, comment: false });
          } else {
            handleClickSnackbar({
              message: t('상세 사유를 입력해주세요.'),
              option: { type: 'error' },
            });
            setError({ ...error, comment: true, adGrpStateCode: false });
          }
        } else {
          handleReqStatus({ ...tempParams, adGrpStateCode: status });
          setError({ ...error, adGrpStateCode: false, comment: false });
        }
      } else {
        if (status === '01') {
          delete tempParams['comment'];
          delete tempParams['adGrpRsnCode'];
        }
        handleReqStatus({ ...tempParams, adGrpStateCode: status });
      }
    } else {
      handleClickSnackbar({
        message: t('상태값을 선택하세요.'),
        option: { type: 'error' },
      });
    }
  };

  const handleReqStatus = (paramsData) => {
    let newParams = { ...paramsData };
    if (!newParams['comment']) {
      delete newParams['comment'];
    }
    changeState(newParams)
      .then((response) => {
        const { message } = response.data;
        handleClickSnackbar({
          message: message,
          option: { type: 'success' },
        });
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: { type: 'error' },
        });
      })
      .finally(() => {
        setReFetch(true);
        setModal({ ...modal, open: false });
      });
  };

  const handleEdit = (data) => {
    setModal({
      ...modal,
      open: true,
      data: data,
      params: {
        mobonAdGrpId: data['MOBON_AD_GRP_ID'],
        adGrpRsnCode: data['AD_GRP_RSN_CODE'],
        comment: data['STATE_COMMENT'],
      },
    });
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
          useExternalFilter={false}
        />
        <FilterCollection
          label={t('승인여부')}
          value={params.adGrpStateCode}
          name="adGrpStateCode"
          type="radio"
          params={params}
          list={approveList}
          labelKey="label"
          valueKey="value"
          callBack={getParam}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={{ sort: 'desc', order: '00' }}
        getParam={(f) => f}
        loading={statusLoading}
        useFetch={false}
        useTotal={false}
        propsList={statusData}
        propsHeadCells={makeHeadData(tableHeadList)}
        useCustomTable
        useStoreLoading={false}
        usePagenation={false}
        useToolBar={false}
        reFetch={reFetch}
      />
      <NewTableContainer
        dataReqPromise={isNormalPage ? normalList : copyList}
        params={params}
        getParam={getParam}
        customized={customized}
        useTotal={false}
        rowsPerPage={200}
        addColumnList={addColumnList}
        useCheckBox
        hasActController={{ edit: true }}
        headCallBack={handleCheckBtnController}
        reFetch={reFetch}
        useFetch={false}
        excelItemsRemoval="MOBON_AD_GRP_ID"
        callBack={() => {
          let newParams = { ...params };
          delete newParams['keyword'];
          getParam(newParams);
        }}
      />
      {modal.open && (
        <ChangeState
          modal={modal}
          adGrpRsnCodeList={adGrpRsnCodeList}
          getParams={getModalParam}
          error={error}
          handleStatus={handleStatus}
          handleModalClose={handleModalClose}
        />
      )}
      {isNormalPage && ImageModal.open && (
        <ImagesModal
          modal={ImageModal}
          handleModalClose={handleImageModalClose}
        />
      )}
    </>
  );
};

export default Creative;
